import $ from 'jquery';
import TweenMax from "gsap/TweenMax";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Parallax from 'parallax-js';
import './animatedPage.js';
import './lib/modernizr-custom.js';

(function () {

	const $body = $('body');
	const $linkSection = $('.SiteHeader li a,.scrolldown,.go-top,.SiteHeader-logo,.barres-content a');
	$linkSection.click(function () {
		const href = $(this.hash);
		if (href) {
			$("html, body").stop().animate({scrollTop: $(href).offset().top - 50}, 1500);
			return false;
		}
	});

	const $btnMenu = $('.btn-menu');
	const $nav = $('.SiteHeader nav'),
		$navItems = $('.SiteHeader a');
	$btnMenu.click(function () {
		$(this).add($nav).toggleClass('active');
		$body.toggleClass('overflow');
	});
	$navItems.click(function () {
		$btnMenu.add($nav).removeClass('active');
		$body.removeClass('overflow');
	});


	const sectionsImg = $('.paralax');
	// if (window.matchMedia("(min-width: 540px)").matches) {
	sectionsImg.each(function (e) {
		const p = new Parallax($(this)[0], {
			clipRelativeInput: true,
		});
	});
	// }

	const $paralEl = $('.paralax-item');
	let scrollTop;
	const h = $(window).height();
	$(window).scroll(function () {
		scrollTop = $(this).scrollTop();
		$paralEl.each(function () {
			const $this = $(this);
			const offset = $this.offset().top;
			const attrSpeed = ($this.attr('data-speed')) ? $this.attr('data-speed') : .1;
			let position = -(scrollTop - offset) * attrSpeed;
			TweenMax.set($this, {y: -position, force3D: true})
		})
	});


})();
